<template>
  <div>
    <PageHeaderLayout>
      <el-button type="" style="margin-bottom: 10px;" @click="goBack()" icon="el-icon-back" size="medium">
        返回
      </el-button>
      <div class="main-page-content" style="margin-top: 20px;">
        <el-row>
          <el-form :inline="true" :model="searchCondition" class="demo-form-inline">
            <el-form-item label="公司名称">
              <el-input v-model="searchCondition.company_name" placeholder="输入公司名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="企业类型">
              <el-select v-model="searchCondition.corp_type" filterable clearable placeholder="请选择">
                <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="负责人手机号">
              <el-input v-model="searchCondition.contact_phone" placeholder="输入负责人手机号" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton">查询</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <ApeTable v-permission:issue_list ref="apeTable" :data="dataList" :columns="columns" :loading="loadingStaus"
          :pagingData="pagingData" highlight-current-row @switchPaging="switchPaging">
          <el-table-column
            slot="first-column"
            align="center"
            label="公司名称">
            <template slot-scope="scope">
              <div>
                {{ scope.row.company_name}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            slot="second-column"
            align="center"
            label="企业类型">
            <template slot-scope="scope">
              <div>
                {{ scope.row.corp_type==1?'人资':'用工' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column width="100" align="center" label="操作">
            <template slot-scope="scope">
              <!-- v-permission:issue_configure -->
              <el-button size="mini" type="text" @click="unbinding(scope.row.id,1)">解绑</el-button>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
  import PageHeaderLayout from "@/layouts/PageHeaderLayout";
  import ModalDialog from '@/components/ModalDialog'
  import UploadFile from "@/components/UploadFile";
  import ApeTable from "@/components/ApeTable";
  import tzForm from "@/components/tz-form";
  import DatePicker from '@/components/DatePicker.vue'
  import {
    mapGetters
  } from 'vuex'
  export default {
    components: {
      tzForm,
      PageHeaderLayout,
      ApeTable,
      ModalDialog,
      UploadFile,
      DatePicker
    },
    data() {
      return {
        not_select: false,
        type: 0,
        id: '',
        formButtonArr: [{
          label: '确定',
          type: 'primary',
          flag: 'add'
        }],
        is_show_form: false,
        loadingStaus: false,
        typeList: [{
            name: '人资公司',
            id: '1'
          },
          {
            name: '用工企业',
            id: '2'
          },
        ],
        // 分页信息
        pagingData: {
          is_show: true,
          layout: 'total, sizes, prev, pager, next, jumper',
          total: 0
        },
        dataList: [{}],
        columns: [
          {
            title: "负责人姓名",
            value: "contact",
            header_align: "center",
            align: "center",
          },
          {
            title: "负责人手机号",
            value: "contact_phone",
            header_align: "center",
            align: "center",
          },
          {
            title: "绑定时间",
            value: "created_at",
            header_align: "center",
            align: "center",
          },
        ],
        searchCondition: {
          company_name: '',
          corp_type: '',
          contact_phone: ''
        }
      };
    },
    watch: {},
    methods: {
      unbinding(arg, val) {
        this.$confirm('点击“确认”后，该公司将被解绑，请仔细确认后在操作', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.unbindingFun(arg, val)
        }).catch(() => {
      
        })
      },
      // 取消资格
      async unbindingFun(id) {
        let data = {
          id:id
        }
        var res = await this.$api.deleteSupplierCustomerInfo(data)
        this.$nextTick(() => {
          if (res) {
            this.$message.success('解绑成功!')
            this.init()
          }
        })
      
      },
      //返回上一页
      goBack() {
        this.$router.push({
          path: "/operator"
        });
      },
      // 重置分页
      async resetPage() {
        this.$refs.apeTable.currentPage = 1
      },
      // 切换页码操作
      async switchPaging() {
        this.init();
      },
      // 搜索
      searchButton() {
        this.resetPage()
        this.init('search')
      },
      //获取列表
      async init(type) {
        if(!this.id) return;
        this.loadingStaus = true
        let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
        let searchCondition = this.handleSearchCondition()
        Object.assign(searchCondition, pagingInfo,{
          supplier_id:this.id
        })
        this.dataList = []
        let {
          data,
          pages
        } = await this.$api.getSupplierCustomerList(searchCondition)
        this.$nextTick(() => {
          this.dataList = data
        })
        this.pagingData.total = pages.total
        this.offset = pages.offset
        this.loadingStaus = false
      },
      // 处理搜索条件
      handleSearchCondition() {
        let condition = {}
        if (this.searchCondition.company_name) {
          condition.company_name = this.searchCondition.company_name
        }

        if (this.searchCondition.corp_type) {
          condition.corp_type = this.searchCondition.corp_type
        }

        if (this.searchCondition.contact_phone) {
          condition.contact_phone = this.searchCondition.contact_phone
        }

        return condition
      }
    },
    computed: {
      ...mapGetters(['userPermissions'])
    },
    mounted() {
      this.resetPage()
      this.id = this.$route.query.id;
      this.init();
    },
  };
</script>

<style lang="scss" scoped>

</style>
